import { useState } from 'react';
import { Link } from 'react-router-dom';
import { SCRAPE_DATA } from '../data/scrapeData';
import { GLOBAL_COMPANY_INFO, getResizedImageUrl } from '../lib/cms';
import GalleryLightbox from '../components/GalleryLightbox';

export default function UdendorsPage() {
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const images = [
    {
      src: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/projekt003.jpg',
      alt: 'Brun træhoveddør med paneler og metalhåndtag',
      title: 'Maling af træhoveddør (Før)',
      tag: 'Før'
    },
    {
      src: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/projekt004.jpg',
      alt: 'Brun hoveddør med hvid karm og lampe',
      title: 'Maling af hoveddør (Efter)',
      tag: 'Efter'
    },
    {
      src: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20250812-144318-scaled.jpg',
      alt: 'Sort træhus med rødt tegltag og have',
      title: 'Sort malet træhus med rødt tegltag'
    },
    {
      src: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20250812-144806-scaled.jpg',
      alt: 'Sort træhus med rødt tegltag og carport',
      title: 'Sort træhus ved carport'
    },
    {
      src: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20250812-144304-scaled.jpg',
      alt: 'Sort træhus med hvid gavl under blå himmel',
      title: 'Træhus med hvid gavl'
    },
    {
      src: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240807-125724-scaled.jpg',
      alt: 'Mørkeblå trægarage med nymalet facade og tagrende',
      title: 'Mørkeblå trægarage'
    },
    {
      src: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240521-125720-scaled.jpg',
      alt: 'Moderne hvidt hus med stor grøn have',
      title: 'Moderne hvid villa'
    },
    {
      src: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240527-112728-scaled.jpg',
      alt: 'Moderne hvidt hus med træterrasse og store vinduer',
      title: 'Hvid villa med træterrasse'
    },
    {
      src: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240527-112222-scaled.jpg',
      alt: 'Nymalet hvid murstensfacade med sorte detaljer',
      title: 'Nymalet murstensfacade'
    }
  ];

  return (
    <div className="bg-[#F8FAFC] pt-28 pb-20">
      
      {/* Banner */}
      <section className="bg-[#1D352E] text-white py-16 mb-16 -mt-[10px]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl space-y-4">
            <span className="text-white text-sm font-semibold tracking-wider uppercase">
              Ydelser / Udendørs
            </span>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight">
              {SCRAPE_DATA.udendors.mainHeading}
            </h1>
            <p className="text-gray-200 text-lg">
              {SCRAPE_DATA.udendors.subHeading}
            </p>
          </div>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-16">
        
        {/* Before / After Highlight */}
        <div className="bg-white rounded-3xl p-8 sm:p-10 border border-slate-200 shadow-sm space-y-8">
          <div className="text-center max-w-2xl mx-auto space-y-2">
            <span className="text-[#65237e] text-xs font-semibold uppercase tracking-wider">
              Eksempel på udendørs træarbejde
            </span>
            <h2 className="text-2xl sm:text-3xl font-bold text-[#1D352E]">
              Før & Efter
            </h2>
            <p className="text-gray-600 text-sm">
              Træhoveddør før og efter professionel opfriskning og behandling.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div
              onClick={() => setLightboxIndex(0)}
              className="relative rounded-2xl overflow-hidden shadow-md border border-gray-200 group cursor-pointer"
            >
              <img
                src={getResizedImageUrl(images[0].src, 800, 85)}
                alt={images[0].alt}
                className="w-full h-80 object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute top-4 left-4 bg-black/70 text-white font-bold text-xs uppercase px-3 py-1.5 rounded-md">
                Før
              </div>
            </div>

            <div
              onClick={() => setLightboxIndex(1)}
              className="relative rounded-2xl overflow-hidden shadow-md border border-gray-200 group cursor-pointer"
            >
              <img
                src={getResizedImageUrl(images[1].src, 800, 85)}
                alt={images[1].alt}
                className="w-full h-80 object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute top-4 left-4 bg-[#1D352E] text-white font-bold text-xs uppercase px-3 py-1.5 rounded-md">
                Efter
              </div>
            </div>
          </div>
        </div>

        {/* Verbatim Scraped Content */}
        <div className="bg-white rounded-3xl p-8 sm:p-12 border border-[#EFECE6] shadow-sm space-y-6">
          <h2 className="text-2xl sm:text-3xl font-bold text-[#1D352E]">
            {SCRAPE_DATA.udendors.subHeading}
          </h2>
          <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
            {SCRAPE_DATA.udendors.body}
          </p>

          <div className="pt-4 flex flex-wrap items-center gap-4">
            <Link
              to="/kontakt"
              className="inline-flex items-center gap-2 px-6 py-3.5 text-sm font-semibold text-white bg-[#65237e] hover:bg-[#521b67] rounded-xl transition-colors shadow-md"
            >
              <span>Kontakt Carsten i dag</span>
              <i className="fa-solid fa-arrow-right text-xs" />
            </Link>
            <a
              href={`tel:${GLOBAL_COMPANY_INFO.phone_raw}`}
              className="inline-flex items-center gap-2 px-6 py-3.5 text-sm font-semibold text-[#1D352E] bg-slate-100 hover:bg-slate-200 rounded-xl transition-colors nowrap-contact"
            >
              <i className="fa-solid fa-phone text-[#65237e]" />
              <span className="nowrap-contact">Ring på {GLOBAL_COMPANY_INFO.phone}</span>
            </a>
          </div>
        </div>

        {/* Gallery Grid */}
        <div className="space-y-6">
          <div className="flex items-center justify-between">
            <h3 className="text-2xl font-bold text-[#1D352E]">
              Billeder fra udendørsprojekter
            </h3>
            <span className="text-xs text-gray-500 font-medium">
              Klik for stor visning
            </span>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {images.map((img, idx) => (
              <div
                key={idx}
                onClick={() => setLightboxIndex(idx)}
                className="group relative rounded-2xl overflow-hidden bg-white border border-[#EFECE6] shadow-sm hover:shadow-xl transition-all duration-300 cursor-pointer"
              >
                <div className="aspect-4/3 overflow-hidden bg-gray-100">
                  <img
                    src={getResizedImageUrl(img.src, 600, 80)}
                    alt={img.alt}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>

      <GalleryLightbox
        images={images}
        currentIndex={lightboxIndex}
        onClose={() => setLightboxIndex(null)}
        onPrev={() => setLightboxIndex((prev) => (prev > 0 ? prev - 1 : images.length - 1))}
        onNext={() => setLightboxIndex((prev) => (prev < images.length - 1 ? prev + 1 : 0))}
      />
    </div>
  );
}
